@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.alias-count {
  background-color: @product-page--tabs--background-color;
  color: @product-page--tabs--text-color;
  border-radius: 25%;
  padding: 1px 4px 3px;
  font-size: 12px;
  margin-left: 5px;
}
